import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';

import { SetTierProtectionDto } from '../domain/types';
import { affiliateManagementService } from '../infra/affiliateManagementService';

interface SetTierProtectionParams {
  projectId: string;
  affiliateId: string;
  body: SetTierProtectionDto;
}

export function useSetTierProtection() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({ projectId, affiliateId, body }: SetTierProtectionParams) =>
      affiliateManagementService.setTierProtection(projectId, affiliateId, body),
    onSuccess: (_data, variables) => {
      toast.success('Tier protection updated');
      queryClient.invalidateQueries({
        queryKey: ['affiliate-management', 'detail', variables.projectId, variables.affiliateId],
      });
      queryClient.invalidateQueries({ queryKey: ['affiliate-management', 'list'] });
      queryClient.invalidateQueries({ queryKey: ['project-affiliates'] });
    },
    onError: (error: Error) => {
      toast.error(error.message || 'Failed to set tier protection');
    },
  });

  return { setTierProtection: mutateAsync, isLoading: isPending };
}
